<template>
  <div
    class="navbar navbar-fixed-top"
    role="navigation"
    data-0="line-height:100px; height:100px; background-color:rgba(0,0,0,0);"
    data-300="line-height:60px; height:60px; background-color:rgba(0,0,0,1);"
  >
    <div
      class="container"
    >
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          data-toggle="collapse"
          data-target=".navbar-collapse"
        >
          <span class="fa fa-bars color-white"></span>
        </button>
        <h1><a
            class="navbar-brand"
            href=""
            data-0="line-height:90px;"
            data-300="line-height:50px;"
          ><img
              src="../assets/img/logo.png"
              alt=""
              style="display: inline;height:60px;width:auto"
            >&nbsp;&nbsp;&nbsp;</a>
        </h1>
      </div>
      <div class="navbar-collapse collapse">
        <ul
          class="nav navbar-nav"
          data-0="margin-top:20px;"
          data-300="margin-top:5px;"
        >
          <li><a
              class="smooth"
              href="http://blog.minhol.cn"
            >我的主页</a></li>
          <li><a
              class="smooth"
              href="http://tec.minhol.cn"
            >个人空间</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style>
</style>

<script>
export default {
  name: "Navbar"
};
</script>